import React from 'react';
import Collapse from '../../Global/Collapse/Collapse';
import Icon from '../../Global/Icons/Icon';

const DiagramCreatorText = () => (
  <Collapse
    show
    trigger={
      <div>
        Text <span className="text-grey">(drag)</span>
        <Icon name="arrow-down" size="m" fill="black" />
      </div>
    }
    content={
      <div className="sidebar-dropdown">
        <ul className="col-3">
          <li>
            <div className="tool-drag text">
              <div id="text" className="tool-drag-svg">
                <Icon name="textbox" size="m" />
                <span className="tool-drag-trigger" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    }
  />
);

export default DiagramCreatorText;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Tools/DiagramCreatorText.js